"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _lodash = require('lodash');

var _videoRoom = require('web/actions/videoRoom');
var _actionCreators = require('shared/actions/actionCreators'); var _actionCreators2 = _interopRequireDefault(_actionCreators);

// Defined by webpack (DefinePlugin), like the globals in types.d.ts.





























































































const initialState = {
  allRooms: {},
  currentVideoRoomKey: '',
  currentVideoRoomSessionDuration: 0,
  currentVideoRoomUser: {
    RoomKey: '',
    RoomUserKey: '',
  },
  anonymousUser: {
    userKey: '',
    userName: '',
    userSecret: '',
  },
  pendingAuthorizations: {},
  searchContext: {
    query: '',
    areArchived: false,
    matchingRoomKeys: [],
    hasDrained: false,
  },
}

exports. default = (
  state = initialState,
  action,
) => {
  // SAFETY: payload and context shapes depend on the action type; each case
  // below narrows them to what its action creator (or wsSend) dispatches.
  const { type } = action
  const payload = action.payload
  const context = action.context 
  switch (type) {
    case _videoRoom.types.FETCH_VIDEO_ROOM.SUCCESS: return {
      ...state,
      searchContext: {
        ...state.searchContext,
        matchingRoomKeys: _lodash.union.call(void 0, 
          state.searchContext.matchingRoomKeys,
          [(payload ).VideoRoom.RoomKey],
        ),
      },
    }
    case _videoRoom.types.SAVE_VIDEO_ROOMS: {
      const rooms = payload 
      const normalizeRoom = (r) => ({
        ...r,
        UserAdmins: _lodash.keyBy.call(void 0, r.UserAdmins, 'UserKey'),
        CurrentRoomUsers: _lodash.keyBy.call(void 0, r.CurrentRoomUsers, 'RoomUserKey'),
        RoomLink: `${VIDEO_ROOM_BASE_URL}/#/vd/${r.RoomKey}`,
      })

      const aggregatedAuthorizations = _lodash.flatten.call(void 0, 
        rooms.map(room => (room.PendingAuthorizations || []).map(
          a => ({ ...a, RoomName: (room.DisplayName || room.Name)  }),
        )),
      )
      const pendingAuthorizations =
        _lodash.keyBy.call(void 0, aggregatedAuthorizations, 'RoomAuthorizationKey')

      return {
        ...state,
        allRooms: _lodash.merge.call(void 0, 
          _lodash.keyBy.call(void 0, rooms.map(normalizeRoom), 'RoomKey'),
          state.allRooms,
        ),
        pendingAuthorizations: _lodash.merge.call(void 0, 
          pendingAuthorizations,
          state.pendingAuthorizations,
        ),
      }
    }
    case _videoRoom.types.SAVE_VIDEO_ROOM_USER:
    case _videoRoom.types.VIDEO_ROOM_USER_PROBLEM_ENCOUNTERED:
    case _videoRoom.types.VIDEO_ROOM_USER_PROBLEM_PUBLISH.REQUEST: {
      const user = payload 
      const room = state.allRooms[user.RoomKey] || {}
      // Existing behaviour kept: this assigns onto the stored room object.
      room.CurrentRoomUsers = room.CurrentRoomUsers || {}
      return {
        ...state,
        allRooms: {
          ...state.allRooms,
          [user.RoomKey]: {
            ...room,
            CurrentRoomUsers: {
              ...room.CurrentRoomUsers,
              [user.RoomUserKey]: {
                ...room.CurrentRoomUsers[user.RoomUserKey],
                ...user,
              },
            },
          },
        },
      }
    }
    case _videoRoom.types.SET_CURRENT_VIDEO_ROOM_KEY: return {
      ...state, currentVideoRoomKey: (payload ).roomKey,
    }
    case _videoRoom.types.REINDEX_MATCHING_ROOM_KEYS: return {
      ...state,
      searchContext: {
        ...state.searchContext,
        matchingRoomKeys: state.searchContext.query
          ? state.searchContext.matchingRoomKeys
          : _lodash.values.call(void 0, state.allRooms)
            .reduce((acc, r) =>
              r.Archived === state.searchContext.areArchived
                // A room is always stored under its RoomKey.
                ? acc.concat(r.RoomKey )
                : acc
            , []),
      },
    }
    case _videoRoom.types.SAVE_SEARCH_MATCHING_ROOM_KEYS: {
      const search = payload 




      return {
        ...state,
        searchContext: {
          query: search.query,
          areArchived: search.areArchived,
          hasDrained: search.matchingRoomKeys.length === 0,
          matchingRoomKeys:
            (search.query === state.searchContext.query &&
            search.areArchived === state.searchContext.areArchived)
              ? state.searchContext.matchingRoomKeys.concat(search.matchingRoomKeys)
              : search.matchingRoomKeys,
        },
      }
    }
    case _videoRoom.types.UPDATE_VIDEO_ROOM: {
      const update = payload 
      return {
        ...state,
        allRooms: {
          ...state.allRooms,
          [update.RoomKey]: {
            ...state.allRooms[update.RoomKey],
            ...update,
          },
        },
      }
    }
    case _videoRoom.types.ADD_VIDEO_ROOM_ADMINS.SUCCESS: {
      // Existing behaviour kept: throws if the room is not in the store.
      const { UserAdmins = {}, TeamAdminKeys = [] } = state.allRooms[context.RoomKey]
      return {
        ...state,
        allRooms: {
          ...state.allRooms,
          [context.RoomKey]: {
            ...state.allRooms[context.RoomKey],
            UserAdmins: {
              ...UserAdmins,
              ..._lodash.keyBy.call(void 0, context.UserAdmins, 'UserKey'),
            },
            TeamAdminKeys: _lodash.union.call(void 0, context.TeamAdminKeys, TeamAdminKeys),
          },
        },
      }
    }
    case _videoRoom.types.REMOVE_VIDEO_ROOM_ADMIN_USER.REQUEST:
    case _videoRoom.types.REMOVE_VIDEO_ROOM_ADMIN_USER.FAILURE: {
      const room = state.allRooms[context.RoomKey] || { UserAdmins: {} }
      return {
        ...state,
        allRooms: {
          ...state.allRooms,
          [context.RoomKey]: {
            ...room,
            UserAdmins: {
              ...room.UserAdmins,
              [context.UserKey]: {
                // Existing behaviour kept: throws if a stored room has no
                // UserAdmins (only possible for rooms not saved via SAVE_VIDEO_ROOMS).
                ...room.UserAdmins[context.UserKey],
                isDeleted: type === _videoRoom.types.REMOVE_VIDEO_ROOM_ADMIN_USER.REQUEST,
              } ,
            },
          },
        },
      }
    }
    case _videoRoom.types.REMOVE_VIDEO_ROOM_ADMIN_USER.SUCCESS: {
      const room = state.allRooms[context.RoomKey] || { UserAdmins: {} }
      // Existing behaviour kept: throws if a stored room has no UserAdmins.
      // eslint-disable-next-line @typescript-eslint/no-unused-vars -- drops the removed admin
      const { [context.UserKey]: removed, ...UserAdmins } = room.UserAdmins
      return {
        ...state,
        allRooms: {
          ...state.allRooms,
          [context.RoomKey]: { ...room, UserAdmins },
        },
      }
    }
    case _videoRoom.types.REMOVE_VIDEO_ROOM_ADMIN_TEAM.REQUEST: {
      const room = state.allRooms[context.RoomKey] || { TeamAdminKeys: [] }
      return {
        ...state,
        allRooms: {
          ...state.allRooms,
          [context.RoomKey]: {
            ...room,
            // Existing behaviour kept: throws if a stored room has no TeamAdminKeys.
            TeamAdminKeys: room.TeamAdminKeys.filter(t => t !== context.TeamKey),
          },
        },
      }
    }
    case _videoRoom.types.REMOVE_VIDEO_ROOM_ADMIN_TEAM.FAILURE: {
      const room = state.allRooms[context.RoomKey] || { TeamAdminKeys: [] }
      return {
        ...state,
        allRooms: {
          ...state.allRooms,
          [context.RoomKey]: {
            ...room,
            // Existing behaviour kept: lodash `union` ignores the plain-string
            // TeamKey, so the removed team is not restored on failure.
            TeamAdminKeys: _lodash.union.call(void 0, 
              room.TeamAdminKeys,
              context.TeamKey ,
            ),
          },
        },
      }
    }
    case _videoRoom.types.UPDATE_ANONYMOUS_USER: return {
      ...state,
      anonymousUser: {
        ...state.anonymousUser,
        ...(payload ),
      },
    }
    case _videoRoom.types.SAVE_PENDING_JOIN_REQUEST: {
      const authorization = payload 
      return {
        ...state,
        pendingAuthorizations: {
          ...state.pendingAuthorizations,
          [authorization.RoomAuthorizationKey]: authorization,
        },
      }
    }
    case _videoRoom.types.UPDATE_CURRENT_VIDEO_ROOM_USER: {
      const { RoomKey, RoomUserKey } = state.currentVideoRoomUser
      const room = state.allRooms[RoomKey] || { CurrentRoomUsers: {} }
      return {
        ...state,
        allRooms: {
          ...state.allRooms,
          [RoomKey]: {
            ...room,
            CurrentRoomUsers: {
              ...room.CurrentRoomUsers,
              [RoomUserKey]: {
                // Existing behaviour kept: throws if a stored room has no CurrentRoomUsers.
                ...room.CurrentRoomUsers[RoomUserKey],
                ...(payload ),
              },
            },
          },
        },
      }
    }
    case _videoRoom.types.SAVE_CURRENT_VIDEO_ROOM_USER: {
      const user = payload 
      return {
        ...state,
        currentVideoRoomUser: {
          RoomKey: user.RoomKey,
          RoomUserKey: user.RoomUserKey,
        },
      }
    }
    case _videoRoom.types.UPDATE_VIDEO_ROOM_PENDING_USER: {
      const response = payload 
      return {
        ...state,
        pendingAuthorizations: {
          ...state.pendingAuthorizations,
          [response.RoomAuthorizationKey]: {
            ...state.pendingAuthorizations[response.RoomAuthorizationKey],
            Approved: response.Approved,
            isResolved: true,
          } ,
        },
      }
    }
    case _videoRoom.types.DISCONNECT_CURRENT_VIDEO_ROOM_USER.SUCCESS: {
      const session = payload 
      return {
        ...state,
        currentVideoRoomSessionDuration: (
          new Date(session.LastDisconnectedAt).getTime() -
          new Date(session.InitialJoinedAt).getTime() || 0
        ) / 1000,
      }
    }
    case _actionCreators2.default.logoutAction.type: return initialState
  }
  return state
}
